<template>
    <div class="">
        <Backer v-if="showbacker != false"/>
        <div style="font-size: 25px; font-weight: bold; margin-bottom: 10px; width: 100%; text-align: center;">Sales</div>

        <div style="text-align: center; padding: 10px; background: #e4f4b6; margin-top: 10px; margin-bottom: 10px;">
            <div style="display: inline-block; margin: 10px; width: auto; background: #efefef; padding: 3px; border: 1px dashed black; font-size: 12px; color: black;">
                <b-card-text>
                    <span>DATES</span>
                    <b-input id="dates" size="sm" variant="dark" :placeholder="[query.startDate, query.endDate].join(' - ')" style="display: inline-block; width: 220px;" autocomplete="off"></b-input>
                    <b-button size="sm" variant="dark" style="display: inline-block;" @click="search_dates">SEARCH</b-button>
                </b-card-text>
            </div>

            <div style="display: inline-block; margin: 10px; width: auto; background: #efefef; padding: 3px; border: 1px dashed black; font-size: 12px; color: black;">
                <b-card-text>

                    <span>INVOICE #: </span>
                    <span>
                        <b-form @submit="search_invoice_id" style="display: inline-block;">
                            <b-form-input v-model="query.invoice_id" size="sm" style="display: inline-block; width: 220px;" autocomplete="off"></b-form-input>
                            <b-button type="submit" size="sm" variant="dark" style="display: inline-block;" >SEARCH</b-button>
                        </b-form>
                    </span>
                </b-card-text>
            </div>

            <div style="display: inline-block; margin-left: auto;">
                <b-form-select 
                    style="width: 200px;"
                    v-on:change="setFilter"
                >
                    <b-form-select-option value="show-finance-only">Finance Only</b-form-select-option>
                    <b-form-select-option value="xx-yy">Some Filter A</b-form-select-option>
                    <b-form-select-option value="xx-yz">Some Filter B</b-form-select-option>
                </b-form-select>
            </div>
        </div>

        <b-overlay :show="sales_being_loaded" rounded="sm">
            <div v-if="sales.length > 0">
                <table style="width: 100%;" id="sales-table">
                    <thead>
                        <tr style="background: black; color: white; font-weight: bold;" >
                            <td class="ipt_tdhr" v-on:click="sortby('datetime')">
                                DATE
                            </td>
                            <td class="ipt_tdhr" v-on:click="sortby('invoice_id')" >
                                INVOICE #
                            </td>
                            <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                LOCATION
                            </td>
                            <td class="ipt_tdhr" v-on:click="sortby('username')">
                                USER
                            </td>
                            <td class="ipt_tdhr">
                                ITEMS
                            </td>
                            <td class="ipt_tdhr">
                                GRAND TOTAL
                            </td>
                            <td class="ipt_tdhr">
                                ACTIONS
                            </td>
                        </tr>
                    </thead> 
                    <tbody>
                        <tr v-for="sale,idx in sales" v-if="showRow(idx)">
                            <td class="ipt_tdr">
                                {{ sale.datetime }}
                            </td>
                            <td class="ipt_tdr" :style="{background: getInvBg(idx)}">
                                {{ ( sale.invoice_id || "" ).toUpperCase() }}
                            </td>
                            <td class="ipt_tdr">
                                {{ ( locationsdict[sale.location_id] || "" ).toUpperCase() }} / {{ (sublocationsdict[sale.sublocation_id] || "").toUpperCase() }}
                            </td>
                            <td class="ipt_tdr">
                                {{ sale.username }}
                            </td>
                            <td class="ipt_tdr">
                                <div v-for="product in sale.items" class="inv_product_label" :style="{'background-color': 'none', 'color': getPrdColor(product) }" >
                                    <span>
                                        {{ product.product_sku }} x <b-badge variant="dark" style="color: white; font-size: 12px;">{{ product.quantity }}</b-badge>
                                    </span>
                                </div>
                            </td>
                            <td class="ipt_tdr">
                                <b>${{ (sale.grand_total || 0.00).toFixed(2) }}</b>
                            </td>
                            <td class="ipt_tdr">
                                <b-button size="sm" variant="success" @click="navigateToInvoice(idx)">View</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import 'lightpick/css/lightpick.css'
    import moment from 'moment'

    export default {
        name: "ListSales",
        props: ["showbacker"],
        components: {Backer, VueGoodTable, Multiselect},
        data: function() {
            return {
                userDetails: {properties: {}},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                sales: [],
                sales_being_loaded: false,
                query: {
                    startDate: null,
                    endDate: null,
                    invoice_id: null,
                },
                sort_asc: true,
                financeonly: false
            }
        },
        methods: {
            setFilter: function(value){
                if (value == 'show-finance-only'){
                    this.financeonly = true;
                }
                else {
                    this.financeonly = false;
                }
            },
            showRow: function(idx){
                let item = this.sales[idx];
                let payment_methods = item.payment_methods;
                console.log(payment_methods, this.financeonly)
                if (this.financeonly){
                    if (payment_methods.indexOf("finance") >= 0){
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return true
                }
            },
            getPrdColor: function(product){
                if (product.is_discount_flag){
                    return "red"
                }
                else if (product.is_special) {
                    return "orange"
                }
                else {
                    return "black"
                }
            },
            getInvBg: function(idx) {

                let item = this.sales[idx];
                console.log(item)
                let payment_methods = item.payment_methods;
                if (payment_methods.indexOf("finance") >= 0) {
                    return "yellow"
                }
                else {
                    return "white"
                }
            },
            search_dates: function(e){
                if (e){
                    e.preventDefault();
                }

                this.query.invoice_id = null;
                if (!this.query.startDate || !this.query.endDate){
                    this.$bvToast.toast(
                        "Please specify a valid date range", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                this.fetch_init();
            },
            search_invoice_id: function(e){
                if (e){
                    e.preventDefault();
                }

                this.query.startDate = null;
                this.query.endDate = null;

                if (!this.query.invoice_id){
                    this.$bvToast.toast(
                        "Please specify a valid invoice id", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                this.fetch_init();
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else{
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function() {
                let that = this;
                let path = "/api/sales/get_sales/";
                let data = {userid: this.userDetails.id, query: this.query};
                console.log(data);
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.sales = response.data.result;
                    }
                    that.sales_being_loaded = false;
                    return
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading sales.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.sales_being_loaded = false;
                    return
                }
                this.sales_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            navigateToInvoice: function(idx) {
                let sale = this.sales[idx];
                let invoice_id = sale.invoice_id;
                this.$router.push("/sales/view_invoice/"+invoice_id+"/");
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.sales = Requestor.sort(this.sales, key)
                }
                else {
                    this.sales = Requestor.sort_reverse(this.sales, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            let userDetails = localStorage.userDetails;
            console.log(this.financeonly)
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                this.fetch_init();


            }
        },
        mounted: function(){
            const Lightpick = require('lightpick');
            let that = this;
            this.query.startDate = moment().add(-7, 'day').format('YYYY-MM-DD');
            this.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            var picker = new Lightpick({
                field: document.getElementById('dates'),
                singleDate: false,
                repick: true,
                startDate: that.query.startDate,
                endDate: that.query.endDate,
                onSelect: function(start, end){
                    // var str = '';
                    // str += start ? start.format('Do MMMM YYYY') + ' to ' : '';
                    // str += end ? end.format('Do MMMM YYYY') : '...';
                    // document.getElementById('result-2').innerHTML = str;
                    console.log(start, end);
                    that.query.startDate = start ? start.startOf('day').format('YYYY-MM-DD') : '';
                    that.query.endDate = end ? end.endOf('day').format('YYYY-MM-DD') : '';

                    console.log(that.query);
                }
            });
        }
    }

</script>
<style scoped>
    td {
        font-size: 14px !important;
        
        padding: 3px;
        background: inherit;
        text-align: center;

    }

    .inv_product_label {
        margin: 5px; 
        padding: 3px; 
        border-radius: 3px; 
        color: black;
        background: #efefef;
        font-size:  14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListSales.vue